<script setup>
import { computed } from 'vue'

import FAQAccordionV1 from '@/components/FAQAccordionV1.vue'
import InputPricingRadio from '@/components/form/InputPricingRadio.vue'
import { useSubscriptionsStore } from '@/stores/SubscriptionsStore'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})

const subscriptionsStore = useSubscriptionsStore()

const selectedSubscription = computed({
  get() {
    return props.modelValue
  },
  set(newSelected) {
    emits('update:modelValue', newSelected)
  }
})

const image = computed(() => {
  if (!selectedSubscription.value) {
    return ''
  }

  return subscriptionsStore.getSubscriptionByCode(selectedSubscription.value).productImage
})

const emits = defineEmits(['update:modelValue', 'onWhatContainsClick'])
</script>

<template>
  <div class="page-sales-funnel-pricing__content">
    <slot></slot>
    <div class="row">
      <div class="col-lg-6">
        <template v-for="subscription in subscriptionsStore.all" :key="subscription.id">
          <div
            v-if="!subscription.variant"
            class="pricing-box pricing-box--simple"
            @click="selectedSubscription = subscription.code"
          >
            <InputPricingRadio
              :data="subscription"
              v-model="selectedSubscription"
              @on-what-contains-click="(payload) => emits('onWhatContainsClick', payload)"
            />
          </div>
        </template>
      </div>

      <div class="col-lg-6">
        <div class="content__image-wrapper">
          <img v-if="image" class="content__image" :src="image" alt="Sales Funnel - Placeholder" />
          <div v-else class="content__image"></div>
        </div>
      </div>
    </div>

    <FAQAccordionV1 />
  </div>
</template>
